import React, { useState } from 'react';
import Button from './Button';
import Buttons from './Buttons';
import CancelButton from './CancelButton';
import ModalCard from './ModalCard';

function Confirmation({ resolve, title = 'Are you sure?', children }) {
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async () => {
    setIsLoading(true);
    await resolve(true);
  };

  return (
    <ModalCard title={title} onClose={() => resolve(false)}>
      <ModalCard.Body>{children}</ModalCard.Body>
      <ModalCard.Footer>
        <Buttons align="right">
          <CancelButton onClick={() => resolve(false)}>Cancel</CancelButton>
          <Button isLoading={isLoading} onClick={handleSubmit}>
            OK
          </Button>
        </Buttons>
      </ModalCard.Footer>
    </ModalCard>
  );
}

export default Confirmation;
